import React, { createRef } from 'react'
import { useTranslation } from 'react-i18next'

import Card from 'components/Shared/Card'
import { TopPerformingTools as TopPerformingToolsType } from 'types/TopPerformingTools'
import CardSkeleton from 'components/Shared/SkeletonStack/Card/CardSkeleton'
import Table from 'components/Shared/Table'
import NoDataComp from 'components/Shared/NoData'
import columns from 'components/Reporting/Overview/GraphicalDetails/TopPerformingTools/Columns'
import GetTable from 'components/Reporting/Overview/GraphicalDetails/TopPerformingTools/GetTable'
import { useAppSelector } from 'redux/Hook'

const PER_PAGE = 5

type TopPerformingToolsCardProps = {
  isLoading: boolean
  topPerformingToolsData: TopPerformingToolsType
}

const TopPerformingTools = ({
  topPerformingToolsData = { data: [], info: '' },
  isLoading,
}: TopPerformingToolsCardProps) => {
  const { t } = useTranslation()
  const {
    stakeholderDashboardDetails: { accessToken = '' },
  }: any = useAppSelector((state) => state)

  // create top performing tools ref
  const createMoreVertRef = createRef<HTMLDivElement>()

  const moreVertProps = {
    moreVertOptions: ['table_pdf', 'csv'],
    moreVertRef: createMoreVertRef,
    fileNameKey: 'topPerformingTools',
  }

  const buildSkeleton = (
    <CardSkeleton showHeaderSkeleton={false} sectionCount={1} height={300} />
  )

  const checkIfDataExists = () => {
    const data = topPerformingToolsData?.data

    if (data?.length > 0) return true
    return false
  }

  const getDataComp = () => {
    const ifData = checkIfDataExists()

    if (ifData) {
      return (
        <>
          {/* create a html table for pdf download */}
          {GetTable(topPerformingToolsData?.data, t)}

          <Table
            height="380px"
            border={false}
            disableColumnMenu
            pageSize={PER_PAGE}
            columns={columns(t)}
            disableColumnSelector
            disableSelectionOnClick
            disableColumnSeparator={true}
            rowsPerPageOptions={[PER_PAGE]}
            rows={topPerformingToolsData?.data}
            showTabelCellWithTooltip={true}
          />
        </>
      )
    }

    return <NoDataComp />
  }

  const topPerformingToolsContent = () => {
    return isLoading ? buildSkeleton : getDataComp()
  }

  return (
    <Card
      topContentSpacing="none"
      info={topPerformingToolsData?.info}
      moreVertProps={moreVertProps}
      cardSizeClass="top-performing-tools"
      content={topPerformingToolsContent()}
      showMoreAction={checkIfDataExists() && !accessToken}
      header={t('reporting.overview.topPerformingTools')}
    />
  )
}

export default TopPerformingTools
